import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UserDto } from '../interfaces/common/userDto';

export interface UserPatStatus {
  provider?: string;
  hasPatConfigured: boolean;
  updatedAt: string | null;
  expiresAt: string | null;
}

export type PatProvider = 'azure-devops' | 'github';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private readonly apiUrl = environment.apiUrl + '/users';

  constructor(private http: HttpClient) {}

  getAllUsers(): Observable<UserDto[]> {
    return this.http.get<UserDto[]>(`${this.apiUrl}/`);
  }

  getPatStatus(provider: PatProvider = 'azure-devops'): Observable<UserPatStatus> {
    return this.http.get<UserPatStatus>(`${this.apiUrl}/me/pat-status`, {
      params: { provider }
    });
  }

  saveUserPat(pat: string, expiresAt: string | null, provider: PatProvider = 'azure-devops'): Observable<{ message: string }> {
    return this.http.put<{ message: string }>(`${this.apiUrl}/me/pat`, { pat, expiresAt, provider });
  }

  validateUserPat(pat: string, provider: PatProvider): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.apiUrl}/me/pat/validate`, { pat, provider });
  }

  testStoredUserPat(provider: PatProvider): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.apiUrl}/me/pat/test`, null, {
      params: { provider }
    });
  }

  removeUserPat(provider: PatProvider = 'azure-devops'): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/me/pat`, { params: { provider } });
  }
}
